import CartSvg from 'components/_common/Icons/SVGIcons/CartSvg';
import { t } from 'i18next';
import { Preloader } from 'modules/admin/components/_common/Preloader';
import { lazy, Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { getCartListAPI } from 'store/customer/actions/CustomerCartAction';
import { cartTotalQuantitySelector } from 'store/customer/selectors/customerCartSelectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const MiniCartModal = lazy(() => import('../Modals/MiniCartModal'));

interface MinCartSectionProps {
  isMobileFooter?: boolean;
  isActive?: boolean;
}

export default function MinCartSection({ isMobileFooter, isActive }: MinCartSectionProps = {}) {
  const cartTotalQuantity = useAppSelector(cartTotalQuantitySelector);
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);

  const ref = useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const trigerCartListAPI = useCallback(() => {
    dispatch(getCartListAPI({}));
  }, [dispatch]);
  useEffect(() => {
    if (show) {
      trigerCartListAPI();
    }
  }, [show, trigerCartListAPI]);
  return (
    <>
      <div
        className={
          isMobileFooter ? 'mobile-footer-bar__item-wrapper position-relative' : 'position-relative'
        }
        ref={ref}
        style={isMobileFooter ? { flex: 1, display: 'flex' } : {}}
      >
        <button
          className={
            isMobileFooter
              ? `mobile-footer-bar__item w-100 ${isActive ? 'is-active' : ''}`
              : 'middle-section__icon-btn'
          }
          aria-label={t('cart')}
          onClick={() => setShow(!show)}
        >
          <CartSvg width={24} height={24} stroke={'currentColor'} fill={'currentColor'} />
          {isMobileFooter && (
            <span className="mobile-footer-bar__label">{t('cart', { defaultValue: 'Cart' })}</span>
          )}
          {cartTotalQuantity > 0 && (
            <span
              className={
                isMobileFooter ? 'cart-item-badge position-absolute' : 'compare-item-badge'
              }
              style={
                isMobileFooter
                  ? {
                      top: '2px',
                      right: 'calc(50% - 20px)',
                      background: 'red',
                      color: '#fff',
                      borderRadius: '50%',
                      fontSize: '10px',
                      padding: '2px 6px',
                    }
                  : {}
              }
            >
              {cartTotalQuantity}
            </span>
          )}
        </button>

        {/* <div style={{ cursor: 'pointer', position: 'relative' }} onClick={() => setShow(!show)}>
          <span>
            <CartSvg width={24} height={24} stroke={'#fff'} fill={'#fff'} />
          </span>
          {cartTotalQuantity > 0 && <span className="cart-item-badge">{cartTotalQuantity}</span>}
        </div> */}
        {show && (
          <Suspense fallback={<Preloader loading={true} />}>
            <MiniCartModal onClose={() => setShow(false)} />
          </Suspense>
        )}
      </div>
    </>
  );
}
